import { render, staticRenderFns } from "./TriggersHistoriesTable.vue?vue&type=template&id=0387edf0&scoped=true"
import script from "./TriggersHistoriesTable.vue?vue&type=script&lang=js"
export * from "./TriggersHistoriesTable.vue?vue&type=script&lang=js"
import style0 from "./TriggersHistoriesTable.vue?vue&type=style&index=0&id=0387edf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0387edf0",
  null
  
)

export default component.exports